export class PremonitionConstants {
    public static readonly PREMONITION_CHANCES: any = {
        win: 0.05,
        freeGames: 0.05,
        pick: 0.05
    };
    public static readonly MIN_WIN_FOR_PREMONITION: number = 10;
    public static readonly PREMONITION_DELAY: number = 500;
    public static readonly BG: any = {
        duration: 500,
        alpha: 0.5
    };
}
